import { useContext } from "react";
import dayjs from "dayjs";
import { GlobalContext } from "GlobalContext";
import { useTranslation } from "react-i18next";
import { addEmployee } from "utils/Employees";
import { useEmployeeForm } from "./hooks/useEmployeeForm";
import { EmployeeFormDialog } from "./EmployeeFormDialog";

interface AddEmployeeProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	reloading: () => void;
}

const AddEmployee = ({ open, setOpen, reloading }: AddEmployeeProps) => {
	const { t } = useTranslation();
	const { handlerAlert } = useContext(GlobalContext);

	const form = useEmployeeForm({ open, setOpen });

	const handleSubmit = () => {
		const { birthDate, getBody, setLoadingSubmit } = form;
		const body = {
			...getBody(birthDate!.format("YYYY-MM-DD")),
			pay_period_end: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
		};
		addEmployee(
			setLoadingSubmit,
			body,
			() => form.closing(true),
			reloading,
			handlerAlert,
			t
		);
	};

	return (
		<EmployeeFormDialog
			open={open}
			title="timekeeper.employees.dialog.add.title"
			submitLabel="settings.paycodes.table.modals.add.buttons.save"
			form={form}
			onSubmit={handleSubmit}
		/>
	);
};

export { AddEmployee };
